import getOperation from "../../helpers/getOperation"

import AuthenticateAsOutputShape from "./AuthenticateAsOutputShape"
import AuthenticateOutputShape from "./AuthenticateOutputShape"
import StartTotpSetupOutputShape from "./StartTotpSetupOutputShape"

export {
  AuthenticateAsOutputShape,
  AuthenticateOutputShape,
  StartTotpSetupOutputShape
}

export const authenticateOperation = getOperation("identity/Authenticate")
export const authenticateAsOperation = getOperation("identity/AuthenticateAs")
export const changeMyIdentityEmailOperation = getOperation("identity/ChangeMyIdentityEmail")
export const confirmMyIdentityEmailOperation = getOperation("identity/ConfirmMyIdentityEmail")
export const startTotpSetupOperation = getOperation("identity/StartTotpSetup")
export const verifyTotpSetupOperation = getOperation("identity/VerifyTotpSetup")
